import { ApiResponse, getAxiosClient, makeApiRequest } from '@givelify/utils';
import { IPointsService } from './IPointsService';
import { PointsEndpoints } from './pointsEndpoints';
import {
    GetPointsBalanceResponse,
    GetPointsDonationInformationResponse,
    GetPointsWithdrawalsHistoryResponse,
    CalculateAmountFromPointsResponse,
    GetPointsSettingsResponse,
    WithdrawPointsResponse,
} from './responses';

export class PointsService implements IPointsService {
    public async getPointsBalance(
        doneeId: number,
    ): Promise<ApiResponse<GetPointsBalanceResponse>> {
        const url = PointsEndpoints.balance(doneeId);
        const httpRequest = getAxiosClient().get(url);
        const result = await makeApiRequest<GetPointsBalanceResponse>(
            httpRequest,
        );
        return result;
    }
    public async getWithdrawalsHistory(
        givingPartnerId: number,
        page: number,
    ): Promise<ApiResponse<GetPointsWithdrawalsHistoryResponse>> {
        const url = PointsEndpoints.withdrawalsHistory(givingPartnerId, page);
        const httpRequest = getAxiosClient().get(url);
        const result =
            await makeApiRequest<GetPointsWithdrawalsHistoryResponse>(
                httpRequest,
            );
        return result;
    }
    public async getDonationInformation(
        doneeId: number,
        donorId: number,
        donationId: number,
    ): Promise<ApiResponse<GetPointsDonationInformationResponse>> {
        const url = PointsEndpoints.donationInformation(
            doneeId,
            donorId,
            donationId,
        );
        const httpRequest = getAxiosClient().get(url);
        const result =
            await makeApiRequest<GetPointsDonationInformationResponse>(
                httpRequest,
            );
        return result;
    }

    public async withdrawPoints(
        doneeId: number,
        amount: number,
    ): Promise<ApiResponse<WithdrawPointsResponse>> {
        const url = PointsEndpoints.withdraw(doneeId);
        const httpRequest = getAxiosClient().post(url, { amount });
        const result = await makeApiRequest<WithdrawPointsResponse>(
            httpRequest,
        );
        return result;
    }

    public async getPointsSettings(
        doneeId: number,
    ): Promise<ApiResponse<GetPointsSettingsResponse>> {
        const url = PointsEndpoints.settings(doneeId);
        const httpRequest = getAxiosClient().get(url);
        const result = await makeApiRequest<GetPointsSettingsResponse>(
            httpRequest,
        );
        return result;
    }

    public async calculateAmountFromPoints(
        doneeId: number,
        amount: number,
    ): Promise<ApiResponse<CalculateAmountFromPointsResponse>> {
        const url = PointsEndpoints.calculate(doneeId);
        const httpRequest = getAxiosClient().post(url, { amount });
        const result = await makeApiRequest<CalculateAmountFromPointsResponse>(
            httpRequest,
        );
        return result;
    }
}
